module.exports = __webpack_public_path__ + "media/images/fast_track-b1168e3df1d06e4463b5d10a1ec23ac4.png";